import { useDispatch, useSelector } from "react-redux";
import { useGetProjectsQuery } from "../../../features/Projects/projectApi";
import { setActiveProjects } from "../../../features/Projects/projectSlice";

export default function ProjectList() {
  const dispatch = useDispatch();
  const activeProjects = useSelector((state) => state.projects.activeProjects);
  const { data, isLoading, isError } = useGetProjectsQuery();

  function isProjectPresent(projectName) {
    return activeProjects.includes(projectName);
  }

  const handleToggleProjects = (e, projectName) => {
    if (e.target.checked) {
      const newActiveProjects = [...activeProjects, projectName];
      dispatch(setActiveProjects(newActiveProjects));
    } else {
      const newActiveProjects = activeProjects.filter(
        (project) => project !== projectName
      );
      dispatch(setActiveProjects(newActiveProjects));
    }
  };

  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">
        {isLoading && <p>Loading...</p>}
        {isError && <p>Error</p>}
        {data &&
          data.map((project) => (
            <div className="checkbox-container" key={project.id}>
              <input
                type="checkbox"
                className={`${project.colorClass}`}
                onChange={(e) => handleToggleProjects(e, project.projectName)}
                checked={isProjectPresent(project.projectName)}
              />
              <p className="label">{project.projectName}</p>
            </div>
          ))}
      </div>
    </div>
  );
}
